<template>
  <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper">
    <!-- 倒计时 -->
    <!--            v-if="ui.is_counter"-->
    <countDown v-if="ui.is_counter" :labelColor="ui.font_color"
               :stime="stime"></countDown>
    <div class="form_wrapper" ref="form_wrapper">
      <!-- 表单部分 -->
      <van-form ref="actionForm">

        <p class="lable_p" v-if="is_name" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">怎么称呼您</p>
        <van-field
            v-if="is_name"
            v-model="action_form.name"
            name="姓名"
            placeholder="请输入姓名"
            class="custom_field"
        />
        <p class="lable_p" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">您的手机号(已加密)</p>
        <van-field
            type="tel"
            v-model="action_form.phone"
            name="电话"
            placeholder="请输入电话"
            class="custom_field"
        />
       <template v-if="is_show_car">
         <p class="lable_p" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}">您的意向车型</p>
          <van-field
              v-model="action_form.car_name"
              is-link
              readonly
              placeholder="请选择意向车型"
              @click="openCarDialog"
              class="custom_field"
          />
       </template>

        <p class="lable_p" :style="{color: `${ui.font_color}` ? `${ui.font_color}` : '#000'}"
           v-if="is_city">快速选择城市</p>
        <van-field
            v-if="is_city"
            v-model="action_form.city"
            is-link
            readonly
            placeholder="请选择城市"
            @click="openCityDialog"
            class="custom_field"
        />
        <!-- <template>
          <div
              class="form_item_btn able_btn"
              round v-if="!is_stop" @click="submitForm"
              :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
            {{ui.btn_text}}
          </div>
          <van-button class="form_item_btn"
                      type="info" round v-if="is_stop" :disabled="true">活动已结束
          </van-button>
        </template> -->

        <div class="main_form_btn">
          <div class="form_btn mt_20" @click="submitForm" :style="`backgroundColor: ${ui.btn_bg_color};`">
             <span  :style="`color: ${is_opacity}`">{{ui.btn_text}}</span>
            <img src="../../assets/image/new_img/pointer_02.png" alt="" class="form_pointer finger_swing" style="z-index: 30">
          </div>
          </div>
          <div class="form_policy pb_14">
            <policy :custom_col='ui.bg_color == "#FFFFFF" ? "#232323" :"#fff"'></policy>
          </div>
      </van-form>
    </div>
    <!-- 走马灯-->
    <!--            v-if="ui.is_banner"-->
    <banner v-if="ui.is_banner"></banner>
  </div>
</template>

<script>
  import countDown from "@/components/countDown";
  import policy from "@/components/policy";
  import copyright from "@/components/copyright";
  import banner from "@/components/banner";
  import carlist_img from "@/components/carlist_img";
  import carlist_noimg from "@/components/carlist_noimg";
  export default {
    name: "form_default",
    components: {
      countDown,
      policy,
      copyright,
      banner,
      carlist_img,
      carlist_noimg,
    },
    data() {
      return {
      };
    },
    props: {
      ui: {
        type: Object,
        default: () => ({}),
      },
      stime: {
        type: Number,
        default: 0,
      },
      action_form: {
        type: Object,
        default: () => ({}),
      },
      is_dialog_car: {
        type: Boolean,
        default: false,
      },
      is_city: {
        type: Boolean,
        default: false,
      },
      city_show: {
        type: Boolean,
        default: false,
      },
      is_stop: {
        type: Boolean,
        default: false,
      },
      is_opacity: {
        type: String,
        default: "#fff",
      },
      is_show_car: {
        type: Boolean,
        default: true,
      },
      tid:{
        type: Number,
        default: 0
      },
      title:{
        type: String,
        default: ''
      },
      is_name:{
        type: Boolean,
        default: true,
      },
    },
    data(){
      return {
        // is_name:true //是否显示姓名
      }
    },
    methods: {
      submitForm() {
        this.$emit("submitForm");
      },
      openCarDialog() {
        this.$emit("openCarDialog");
      },
      openCityDialog() {
        this.$emit("openCityDialog");
      },
    },
    watch: {
      // title(v) {
      //   this.is_name = !(this.title.indexOf('家博会')>-1 && this.tid == 5)
      //   console.log(this.is_name);
      // },
    }
  }
</script>

<style lang="less" scoped>
  /*todo 表单样式冲突，*/
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/form.less";
  // form
  @import "../../assets/style/common/successful.less";
  //报名成功
  @import "../../assets/style/autoshow/base_form.less";
  .pb_14{
    padding-bottom: 14px;
  }
</style>